import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const modalContentCss = "m18ujvzi";
const ModalContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalContentCss, props.className)} />;
});
const closeButtonSizeLargeCss = "c1ki19ru";
const closeButtonCss = "c1xhewb9";
const CloseButton = forwardRef((props, ref) => {
  const {
    size = 'large',
    ...restProps
  } = props;
  const name = 'close';
  return <BareButton ref={ref} {...restProps} name={name} aria-label="Close" className={classNames(closeButtonCss, {
    [closeButtonSizeLargeCss]: size?.toString() === 'large'
  }, props.className)}>
      <CloseIcon size={useDeviceType('isPhone') ? 'large' : size} />
    </BareButton>;
});
const navigatorItemsCss = "nr23wee";
const NavigatorItems = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorItemsCss, props.className)} />;
});
const navigatorWrapperUseUpdatedDesignCss = "nixjm0q";
const navigatorWrapperIsPhoneCss = "n4lidxh";
const navigatorWrapperIsBigPhoneUpCss = "nprrdid";
const navigatorWrapperStepNameDetailsStepCss = "n1fmbgrm";
const navigatorWrapperStepNameShareStepCss = "n1a1xihu";
const navigatorWrapperStepNameTimeStepCss = "n1vku0uw";
const navigatorWrapperIsSmallPhoneCss = "n1bpeoy6";
const navigatorWrapperCss = "n1ki1e6c";
const NavigatorWrapper = forwardRef((props, ref) => {
  const {
    useUpdatedDesign,
    stepName,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isSmallPhone = useDeviceType('isSmallPhone');
  const isBigPhoneUp = useDeviceType('isBigPhoneUp');
  return <Component ref={ref} {...restProps} className={classNames(navigatorWrapperCss, {
    [navigatorWrapperUseUpdatedDesignCss]: useUpdatedDesign,
    [navigatorWrapperIsPhoneCss]: isPhone,
    [navigatorWrapperIsBigPhoneUpCss]: isBigPhoneUp,
    [navigatorWrapperStepNameDetailsStepCss]: stepName?.toString() === 'details_step',
    [navigatorWrapperStepNameShareStepCss]: stepName?.toString() === 'share_step',
    [navigatorWrapperStepNameTimeStepCss]: stepName?.toString() === 'time_step',
    [navigatorWrapperIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
export { ModalContent, CloseButton, NavigatorItems, NavigatorWrapper };

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");